import { Helmet } from "react-helmet-async";

const Privacy = () => (
  <>
    <Helmet>
      <title>Privacy Policy | Elevate Global Solutions</title>
      <meta name="description" content="How Elevate Global Solutions collects, uses, and protects information from US real estate investors and visitors." />
      <link rel="canonical" href="https://www.elevateglobalsolutions.net/privacy" />
    </Helmet>
    <section className="section-padding">
      <div className="container-narrow max-w-3xl">
        <div className="gold-divider" />
        <h1 className="mt-4 font-display text-4xl font-bold text-foreground">Privacy Policy</h1>
        <p className="mt-2 text-sm text-muted-foreground">Last updated: May 2026</p>

        <div className="mt-6 rounded-xl border border-secondary/40 bg-accent/60 p-5">
          <p className="text-sm leading-relaxed text-foreground">
            We use industry-standard security practices to protect your
            information. We never sell your personal data and do not share it
            with third parties for advertising or marketing purposes.
            Information submitted through our website is used only to provide
            services, respond to inquiries, improve website performance, and
            support legitimate business operations.
          </p>
        </div>

        <div className="prose prose-neutral mt-8 max-w-none text-foreground">
          <h2 className="mt-8 font-display text-xl font-bold">1. Information we collect</h2>
          <p className="mt-2 text-muted-foreground">
            We collect information you submit through our contact and booking forms (name, business
            email, phone number, company, industry, message). We also collect first-party analytics
            data we generate ourselves (pages viewed, referrer, approximate device type, scroll
            depth, button clicks, and an anonymous visitor identifier stored in your browser) to
            understand site performance and improve user experience. We do not use third-party
            advertising trackers or cross-site tracking pixels.
          </p>

          <h2 className="mt-8 font-display text-xl font-bold">2. How we use information</h2>
          <p className="mt-2 text-muted-foreground">
            We use form submissions to respond to inquiries, schedule strategy calls, deliver our
            services, and send occasional operational updates. We use first-party analytics to
            measure traffic, diagnose issues, prioritize content, and manage incoming leads. We do
            not sell your data.
          </p>

          <h2 className="mt-8 font-display text-xl font-bold">3. Sharing</h2>
          <p className="mt-2 text-muted-foreground">
            We share data only with vetted infrastructure providers (hosting, CRM, scheduling, email
            delivery) strictly to operate the service. All providers are bound by data-processing
            agreements.
          </p>

          <h2 className="mt-8 font-display text-xl font-bold">4. Your rights</h2>
          <p className="mt-2 text-muted-foreground">
            You can request access, correction, or deletion of your information at any time by
            emailing <a href="mailto:abdelrahaman@elevateglobalsolutions.net" className="text-secondary underline">abdelrahaman@elevateglobalsolutions.net</a>.
          </p>

          <h2 className="mt-8 font-display text-xl font-bold">5. Contact</h2>
          <p className="mt-2 text-muted-foreground">
            Elevate Global Solutions · abdelrahaman@elevateglobalsolutions.net · (214) 296-2124
          </p>
        </div>
      </div>
    </section>
  </>
);

export default Privacy;
